import { useEffect } from "react";

/** Marks player routes so chrome CSS can target body.player-body if needed. */
export function usePlayerChrome(): void {
  useEffect(() => {
    document.body.classList.add("player-body");
    return () => {
      document.body.classList.remove("player-body");
    };
  }, []);
}
